import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import Collapisble from '../../../../components/Collapsible';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/early-years/layoutProps';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="ibpyp-at-kik">
    <h1>從幼稚園開始推行小學課程項目(IBPYP)</h1>
    <p>
      京斯敦國際學校是香港首間獲授權認可採用國際文憑組織小學課程項目的學校。此課程設計適合三至十二歲的小朋友，學生以探究的方式去學習，內容十分國際化。
    </p>
    <p>
      小學課程項目旨在培養學生全人發展，並成為身心健康的人。課程鼓勵學生成為思考者及解決問題者，提升他們的創造力及關心他人的個人特質。此課程在世界各地被認可為具高學術水平的課程，並且為學生將來在香港或海外繼續升學作好準備。此外，京斯敦國際學校亦將國際文憑組織的理念融入校園生活的各個範疇裏。
    </p>

    <h3>課程的超學科性質</h3>
    <p>在京斯敦，我們非常著重以下學科的重要性：語言；數學；社會學；科學；藝術；個人教育、社交教育和體育。</p>
    <p>課程的《學習範圍與順序》中詳細記載構成每個學科領域的知識、概念和技能，並設定對每個學科的總體要求。</p>
    <p>
      然而，我們認為單獨的學科來教育學生雖是必要，卻是不夠的。同樣重要的是，學生需要在一定的情境中掌握技能，探索與他們相關的學習內容，並超越傳統學科之間的界限開展學習。「要真正受到教育，學生還必須能夠在各個學科之間建立聯繫，發現將各個學科整合起來的方法，最終做到學以致用、知行合一」。(Boyer
      1995: 82)
    </p>
    <p>
      課程的超學科主題，含括了人類都會體驗的領域，對文化和種族背景各異的個人都別具意義。這些主題為所有開設小學項目課程的國際文憑學校具一致性的學習，並奠定了部分共同的基礎。它們提供了對本地問題和全球性問題一體化的機會，而這些問題都屬於小學項目書面課程──「我們希望學生學習什麼」的知識範疇。課程共有六個超學科主題，而幼稚園的課程則包含其中四個主題。六個超學科主題包括【我們是誰】、【我們如何表達自己】、【我們身處什麼時空】、【共享地球】、【我們如何組織自己】和【世界如何運作】。透過這些超學科主題，學生探索和學習本地與全球的重要事件。我們的英文和中文老師一起合作計劃這些單元，確保符合年幼學習者的需要，並且能夠培養學生重要的態度、技能、概念、知識和學習者培養目標的特質。
    </p>

    <Collapisble trigger="雙語學習">
      <React.Fragment>
        <p>
          京斯敦語言學習的目標是培養孩子在溝通時的能力和自信心，因此每班各有一名母語為英語及一名母語為普通話的合資格老師擔任班主任。本校的學習環境支援雙語學習，讓孩子有不同和充分的機會去觀察、聆聽、回應、發問和參與對話，使新的學習經驗變得更有意義。孩子每天都會隨時隨意地使用英語和普通話交談，因此可同時培養這兩種語言的發展。另外，每天的圍圈時間也能夠讓孩子專注於某一種語言的發展。
        </p>
        <p>
          三歲及四歲班的教學目標是培養孩子對閱讀和寫作的渴求。如果希望讓孩子成為成功的讀者和作者，他們必須喜愛閱讀、喜愛書籍和喜愛語言。另外，要孩子學習寫作，必須先讓他們渴求寫作。當孩子說話和聆聽時，其實也在學習閱讀和寫作；他們寫作的同時亦能夠提升閱讀能力；而當他們閱讀和寫作時，也會提升其說話能力。在教室裏，老師和孩子一起經歷的每一個學習過程，都有助提升孩子的閱讀和寫作能力。幼稚園的孩子會變得更有能力和自信地以雙語去表達自己，我們也鼓勵孩子在遊玩時使用英語及普通話，以支援同儕間的語言學習。老師會示範正確的語言和句子結構、稱讚孩子所付出的努力和所作出的嘗試，而不是去改正他們的語言。特別是在單元探究期間，老師會運用廣泛和較為複雜的詞彙，以挑戰和擴展孩子的說話能力。
        </p>
        <h5>書寫</h5>
        <p>
          老師會訓練孩子書寫前的相關技巧，如小肌肉發展、手眼協調及方位的概念。當孩子升上四歲班後，才開始進行指定的漢字書寫活動。老師會觀察每個孩子的進展，留意個別孩子的書寫能力。英文科方面，我們會以實際目的作為寫作內容，如創作清單列表、告示、書信或信息，從而讓孩子學習發音、字母、字詞及句子，還有說出寫作的內容。此外，老師也會細心觀察一些寫前指標，並按照孩子的技巧和興趣，鼓勵孩子去書寫或完成寫前練習。
        </p>
        <h5>閱讀──英文科</h5>
        <p>
          我們的教學目的是讓學生明白他們所閱讀的內容的意思，而並不希望孩子靠死記硬背的方式去學習字詞，故此不會讓他們把字母卡或詞卡帶回家。我們的目標是讓孩子首先了解字母及其發音的關係，再學習字詞，以訓練孩子的閱讀技巧，而這些活動更有助孩子的英文閱讀發展。
        </p>
        <p>
          在京斯敦，所有班級的學生都會學習音標。當孩子升上四歲班後，他們會更集中學習字母及其發音的關係，老師亦會教授閱讀文章的一些策略。有些孩子已經能夠在閱讀和寫作活動中運用這些策略，有些孩子可能暫未能運用這些技巧。請緊記，每個孩子都是獨立的個體，就算是同一班的孩子，他們也有不同的發展速度。正式的音標課程將於京斯敦小學一年級展開，此時孩子已經能夠運用在幼稚園習得的閱讀和寫作知識。
        </p>
        <h5>閱讀──中文科</h5>
        <p>
          我們的目標是培養所有孩子的閱讀興趣，建立正面的閱讀習慣。在孩子升上小學前，我們的目的是讓他們認識常用字詞(利用詞卡)和與探究單元相關的詞彙。老師會使用一些孩子易於理解的字詞和句子，並逐漸適當地增加漢字量。此外，我們也鼓勵學生積累和使用這些漢字並擴展認識更多詞彙量。
        </p>
        <h5>聆聽及說話</h5>
        <p>
          京斯敦的老師會示範語言的正確運用法，並鼓勵學生在溝通時保持眼神接觸。上課期間，無論在遊戲、演出話劇、單元活動、一般討論或圍圈時間，學生都有很多聆聽和說話的機會。老師讓學生有足夠的時間去思考和說話，以及利用歌曲、詩歌和故事去幫助孩子認識新詞彙。透過我們的探究單元，學生學習有目的和在不同情境下的聆聽和說話。
        </p>
      </React.Fragment>
    </Collapisble>

    <Collapisble trigger="數學科">
      <React.Fragment>
        <p>
          學生會透過全年的四個探究單元探索數學概念，我們的教學方法是讓學生透過把概念和技能應用到真實情境中去探索和學習。此外，我們還有很多親身學習的機會，以鼓勵學生主動參與活動和與老師討論問題。京斯敦的學生會學習數學科的五大範疇：
        </p>
        <ul className="list">
          <li>算術</li>
          <li>數據處理</li>
          <li>模式及函數</li>
          <li>測量</li>
          <li>形狀與空間</li>
        </ul>
        <p>
          當學生由三歲班升上四歲班後，他們會繼續學習和擴展這些數學概念及技能，以充分理解和應用它們。我們的數學科以普通話及英語教授。
        </p>
      </React.Fragment>
    </Collapisble>

    <Collapisble trigger="社會學科">
      <p>
        三歲及四歲班的社會學科已經包含在全年四個探究單元裏，內容則根據《社會學學習範圍與順序》內的五大範疇而編寫。這些範疇集中探討人類、經驗、環境、資源以及我們如何與環境互動。
      </p>
    </Collapisble>

    <Collapisble trigger="科學科">
      <p>
        京斯敦的學生透過超學科主題學習科學的所有三個領域(生物、化學和物理)。學生進行戶外考察、做實驗、親身體驗活動、提出假設和觀察事物，以掌握《科學學習範圍與順序》內的四大範疇不同科學概念的相關知識、理解和技能。
      </p>
    </Collapisble>

    <Collapisble trigger="個人教育、社交教育和體育科">
      <p>
        為幫助學生全人發展，京斯敦的學生也會探索個人教育、社交教育及體育的學科。本校有一名專科老師，負責教授四歲班的體育課。三歲班每個星期都有體育課，由班主任教授。京斯敦的體育課程不但提升孩子的體能發展，同時有助提升其社交、情緒及心理發展。學生會透過一系列具挑戰性的團體及個人活動遊戲來探索個人的身體機能，學習與他人合作，以及安全使用運動器材。小學項目課程的超學科性質，使專科老師能與班主任緊密合作。
      </p>
    </Collapisble>

    <Collapisble trigger="藝術科──音樂、美術及戲劇">
      <p>
        藝術科融入本校的課程當中，透過一系列刺激學生發展的活動，他們可以自由地以視覺或音樂方式表達自己。藝術學習可以培養孩子的創造力、自發性、幻想力、獨立性和自信心，而這些特質對所有學習層面都十分重要。此外，藝術科使我們的學生能夠探索自身和其他的文化。
      </p>
    </Collapisble>
  </ContentLayout>
);
